<template>
    <b-overlay :show="typeLoading" opacity="0.2">
        <b-modal id="edit" :title="[[$safe(editingScore,'Employee.FirstName') || null,$safe(editingScore,'Employee.LastName') || null].filter(n=>n).join(' '), editingScore.Date].filter(n=>n).join(' - ')" no-close-on-esc no-close-on-backdrop>
            <daily-score-editor v-model="editingScore" :types="types"></daily-score-editor>
            <template #modal-footer><v-executer :loading="saving" :action="save" text="Güncelle"></v-executer></template>
        </b-modal>

        <b-modal id="create-free" title="Günlük Puantaj" no-close-on-esc no-close-on-backdrop>
            <daily-score-free-create v-model="freeScore" :types="types"></daily-score-free-create>
            <template #modal-footer><v-executer :loading="saving" :action="saveFree" text="Kaydet"></v-executer></template>
        </b-modal>

        <b-card no-body>
            <v-table    ref="table"
                        name="daily-score-monthly-edit"
                        :items-provider="provider"
                        pagination="server"
                        v-on:component-action="edit"
                        search
                        :fields="fields"
                        v-on:refresh="onTableResfreh"
                        :initial-load="false">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="month">
                                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="year">
                                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                    </select>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success btn-block" v-on:click="$refs.table.refresh()">
                                        Sorgula
                                    </button>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-flat-primary btn-block" v-on:click="createFree">
                                        Oluştur / Güncelle
                                    </button>
                                </div>
                            </div>
                        </template>
                        <template #filters>
                            <daily-score-filter v-on:filter="filter"></daily-score-filter>
                        </template>
            </v-table>
        </b-card>
    </b-overlay>
</template>

<script>
import { BCard,BOverlay } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
import moment from 'moment'
import DailyScoreEditor from './components/DailyScoreEditor.vue'
import DailyScoreFreeCreate from './components/DailyScoreFreeCreate.vue'
import DailyScoreFilter from './components/DailyScoreFilter.vue'

export default {
    components:{
        BCard,
        BOverlay,
        DailyScoreEditor,
        DailyScoreFreeCreate,
        DailyScoreFilter
    },
    data(){
        return{
            year:null,
            years:[],
            showingYear:null,
            month:null,
            showingMonth:null,
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            daysOfMonth:[],
            datas:[],
            loading:false,
            typeLoading:false,
            types:[],
            editingScore:{
                Employee:null,
                Date:null,
                DriverScoreTaskId:null,
                EmployeeWorkingTypeId:null
            },
            freeScore:{
                EmployeeId:null,
                Date:null,
                EmployeeWorkingTypeId:null,
                DriverScoreTaskId:null,
            },
            saving:false,
            fields:[],
            filterData:{
                BranchId:null,
                Driver:null,
            }
        }
    },
    mounted(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureDaysOfMonth(Date.now())
        this.configureFields()
        this.getWorkingTypes()
    },
    methods:{
        clearForm(){
            this.editingScore.Employee = null
            this.editingScore.Date = null
            this.editingScore.DriverScoreTaskId = null
            this.editingScore.EmployeeWorkingTypeId = null
            this.freeScore.Date = null
            this.freeScore.EmployeeId = null
            this.freeScore.EmployeeWorkingTypeId = null
            this.freeScore.DriverScoreTaskId = null
        },
        createFree(){
            this.clearForm()
            this.$showModal('create-free')
        },
        saveFree(){
            this.saving = true
            EmployeeOperationsApi.Score.CreateOrUpdateDailyScore({Dasy:[{
                EmployeeId:this.freeScore.EmployeeId,
                Date:this.freeScore.Date,
                EmployeeWorkingTypeId:this.freeScore.EmployeeWorkingTypeId,
            }]}).then(res=>{
                this.$result(res)
                this.saving = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-free')
                }
            }).catch(err=>{
                this.saving = false
                this.$result(null,err)
            })
        },
        edit(employee,date,driverScoreTaskId,employeeWorkingTypeId){
            this.editingScore.Employee = employee || null
            this.editingScore.Date = date || null
            this.editingScore.DriverScoreTaskId = driverScoreTaskId || null
            this.editingScore.EmployeeWorkingTypeId = employeeWorkingTypeId || null
            this.$showModal('edit')
        },
        configureDaysOfMonth(date){
            this.daysOfMonth = []
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.daysOfMonth.push(_dateForName)
            })
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        provider(data){
            return EmployeeOperationsApi.Score.GetDailyScoreMonthly({
                PaginateRequest:data,
                Month:this.month,
                Year:this.year,
                ...this.filterData
            })
        },
        onTableResfreh(){
            this.showingYear = this.year
            this.showingMonth = this.month
            let date = moment(this.year+'-'+this.month,'YYYY-MM')
            this.configureDaysOfMonth(date)
            this.configureFields()
        },
        configureFields(){
            let fields = [
                {name:'Personel',key:'Employee.FullName',thClass:'w-30',tdClass:'text-nowrap'},
                {name:'Kimlik Numarası',key:'Employee.IdentityNumber',thClass:'w-20'},
                {name:'Şube',key:'Employee.BranchName',thClass:'w-20'},
                {name:'Görev Yeri',key:'Employee.GarageName',thClass:'w-25',tdClass:'text-nowrap'},
                {name:'Giriş Tarihi',key:'Employee.JobStartDate',tdClass:'text-nowrap'},
                {name:'Çıkış Tarihi',key:'Employee.JobEndDate',tdClass:'text-nowrap'},
            ]
            this.daysOfMonth.forEach(d=>{
                fields.push({
                    name:moment(d,'DD.MM.YYYY').locale('tr').format('DD ddd'),
                    key:`["Days","${d}"]`,
                    tooltip:moment(d,'DD.MM.YYYY').locale('tr').format('DD MMMM YYYY dddd'),
                    thClass:'table-vertical-text',
                    component:true,
                    componentOptions:{name:"daily-score-edit-cell/DailyScoreEditCell"},
                    tdClass:'p-0 text-center border-right'
                })
            })
            this.fields = fields
        },
        getWorkingTypes(){
            return new Promise(resolve=>{
                this.typeLoading = true
                EmployeeOperationsApi.Score.WorkingType().then(res=>{
                    this.typeLoading = false
                    this.types = res.data.Data
                    resolve()
                }).catch(err=>{ this.typeLoading = false })
            })
        },
        save(){
            this.saving = true
            EmployeeOperationsApi.Score.CreateOrUpdateDailyScore({Days:[{
                Id:this.editingScore.DriverScoreTaskId,
                EmployeeId:this.editingScore.Employee.Id,
                Date:moment(this.editingScore.Date,'DD.MM.YYYY').format('YYYY-MM-DD'),
                EmployeeWorkingTypeId:this.editingScore.EmployeeWorkingTypeId
            }]}).then(res=>{
                this.$result(res)
                this.saving = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('edit')
                }
            }).catch(err=>{
                this.saving = false
                this.$result(null,err)
            })
        },
    },
}
</script>

<style lang="scss">
@use "sass:map";

$types-bg:(
    'indigo': #8888ca,
    'pink': #a17191,
    'green': #83974a,
    'purple': #9a779b,
    'light-orange': #c1aca8,
    'dark-green': #9a997e,
    'yellow': #c7bf41,
    'red': #bc797e,
    'clean': #ffffff,
    'orange': #a87a4e,
    'teal': #8cbde5,
    'blue': #46b5d4,
    'gray': #9ea3c0,
);

$types-color:(
    'indigo': hsl(240, 38%, 33%),
    'pink': hsl(320, 20%, 21%),
    'green': hsl(76, 34%, 11%),
    'purple': hsl(298, 15%, 21%),
    'light-orange': hsl(10, 17%, 38%),
    'dark-green': hsl(58, 12%, 21%),
    'yellow': hsl(56, 54%, 19%),
    'red': hsl(356, 33%, 28%),
    'clean': hsl(0, 0%, 0%),
    'orange': hsl(29, 37%, 15%),
    'teal': hsl(207, 63%, 38%),
    'blue': hsl(193, 62%, 22%),
    'gray': hsl(231, 21%, 36%),
);

$types-bg-color:(
    'indigo': hsl(240, 38%, 65%),
    'pink': hsl(320, 20%, 53%),
    'green': hsl(76, 34%, 43%),
    'purple': hsl(298, 15%, 53%),
    'light-orange': hsl(10, 17%, 60%),
    'dark-green': hsl(58, 12%, 53%),
    'yellow': hsl(56, 54%, 51%),
    'red': hsl(356, 33%, 60%),
    'clean': hsl(0, 0%, 62%),
    'orange': hsl(29, 37%, 55%),
    'teal': hsl(207, 63%, 65%),
    'blue': hsl(193, 62%, 60%),
    'gray': hsl(231, 21%, 63%),
);

@each $class,$color in $types-bg{
    .type-#{$class}{
        background-color: $color !important;
        color: map.get($types-color,$class) !important;
    }
    .type-bg-#{$class}{
        background-color: lighten(map.get($types-bg-color,$class), 30%);
        color: map.get($types-color,$class) !important;
    }
};

.v-table{
    height: 1px;
}
</style>